<template>
  <div class="page-footer">
    <footer class="footer border-0 pt-0">
      <div class="container footer-content">
        <div class="page-footer-cols">
          <div class="footer-col">
            <h2>Kontakt</h2>
            <div class="contact">
              <address>
                Kreis Coesfeld - 50 - Soziales und Jobcenter<br>
                Schutzenwall 18<br>
                48653 Coesfeld
              </address>
              <address>
                <span class="icon-row">
                  <b-icon icon="telephone-fill" aria-hidden="true" class="footer-icon"></b-icon>
                  02541 18-5800
                </span>
                <span class="icon-row">
                  <b-icon icon="printer-fill" aria-hidden="true" class="footer-icon"></b-icon>
                  02541 18-5899
                </span>
              </address>
              <address>
                <span class="icon-row">
                  <b-icon icon="envelope-fill" aria-hidden="true" class="footer-icon"></b-icon>
                  <a href="mailto:jobcenter@kreis-coesfeld.de" class="footer-link">jobcenter@kreis-coesfeld.de</a>
                </span>
                <span class="icon-row">
                  <b-icon icon="pencil-fill" aria-hidden="true" class="footer-icon"></b-icon>
                  <a
                    href="https://formulare.kreis-coesfeld.de/metaform/Form-Solutions/sid/assistant/66d158d65fa44d6d02bafe64"
                    target="_blank"
                    rel="noreferrer"
                    class="footer-link"
                  >
                    Kontaktformular
                  </a>
                </span>
              </address>
            </div>
          </div>

          <nav class="footer-col" aria-label="Service / Hilfsmenu">
            <h2>Service</h2>
            <div class="nav-meta">
              <ul>
                <li v-for="(item, index) in serviceLinks" :key="index">
                  <a :href="item.href" :target="item.target" :rel="item.rel" class="footer-link">
                    {{ item.label }}
                  </a>
                </li>
              </ul>
            </div>
          </nav>

          <div class="page-footer-logo">
            <a
              :href="baseUrl"
              class="space"
              aria-label="Zur Webseite des Kreis Coesfeld"
              title="Link zum Kreis Coesfeld"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="@/assets/img/logo/logo-coe_inv.png" alt="Kreis Coesfeld" />
            </a>
          </div>
        </div>

        <div class="copyright py-3">
          <p>
            {{ translation[10544] }}
            <a
              href="https://www.jobnet.ag"
              target="_blank"
              rel="noopener"
              class="footer__link"
              style="color: #fff !important; text-decoration: underline !important;"
              title="zur Website der Jobnet.AG"
            >Jobnet.AG</a>
            &copy; {{ new Date().getFullYear() }} |
            {{ translation[16015] }} |
            <button
              @click="showCookieSettings"
              class="footer__link footer__link--button button_base"
              style="color: #fff !important; text-decoration: underline !important;"
            >
              {{ translation[10545] }}
            </button>
          </p>
        </div>
      </div>
    </footer>

    <b-modal
      v-model="privacyModal"
      hide-header
      ok-only
      size="xl"
      centered
      scrollable
    >
      <div v-html="privacyText"></div>
    </b-modal>
  </div>
</template>

<script lang="ts">
import { AppModule } from '@/store/modules/app';
import { Component, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PrivacyPolicyMixin from '@/mixins/PrivacyPolicyMixin';

const KREIS_COESFELD_BASE_URL = 'https://www.kreis-coesfeld.de';

@Component
export default class FooterComponentCoe extends mixins(PrivacyPolicyMixin) {
  get translation() {
    return AppModule.translation;
  }

  get baseUrl() {
    return KREIS_COESFELD_BASE_URL;
  }

  get serviceLinks() {
    const base = this.baseUrl;
    return [
      { href: `${base}/impressum`, label: 'Impressum' },
      { href: `${base}/datenschutz`, label: 'Datenschutz' },
      { href: `${base}/elektronische-kommunikation`, label: 'Elektronische Kommunikation' },
      { href: `${base}/barrierefreiheit`, label: 'Barrierefreiheit' },
      { href: `${base}/leichte-sprache`, label: 'Leichte Sprache' },
      { href: `${base}/gebaerdensprache`, label: 'Gebardensprache' },
      { href: `${base}/hinweisgeberschutz`, label: 'Hinweisgeberschutz' },
      { href: `${base}/inhaltsverzeichnis`, label: 'Inhaltsverzeichnis' },
      { href: `${base}/anmelden`, label: 'Anmelden' },
      {
        href: 'https://www.kreis-coesfeld.de/media/default/Allgemein/Downloads/TeamViewerQS_x64.exe',
        label: 'Fernwartung',
        target: '_blank',
        rel: 'noreferrer',
      },
    ];
  }
}
</script>

<style lang="scss">
[sid="coe"][theme="default"] {
  .page-footer .footer {
    background: #507f9d;
    color: #fff;
  }

  .page-footer .footer-content {
    padding-top: 2.25rem;
  }

  .page-footer .page-footer-cols {
    display: flex;
    gap: 2rem;
    justify-content: space-between;
    align-items: flex-start;
  }

  .page-footer .footer-col {
    flex: 1 1 0;
  }

  .page-footer .footer-col h2 {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: .75rem;
    color: #fff;
  }

  .page-footer .footer-col address {
    margin-bottom: .75rem;
    font-style: normal;
    line-height: 1.6;
  }

  .page-footer .icon-row {
    display: flex;
    align-items: center;
    gap: .5rem;
    margin-bottom: .25rem;
  }

  .page-footer .footer-icon {
    flex: 0 0 auto;
  }

  .page-footer .nav-meta ul {
    list-style: disc;
    padding-left: 1.1rem;
    margin: 0;
  }

  .page-footer .nav-meta li {
    margin-bottom: .15rem;
  }

  .page-footer .footer-link,
  .page-footer .footer-link:visited {
    color: #fff;
    text-decoration: underline;
  }

  .page-footer .footer-link:hover {
    color: #fff;
    text-decoration: none;
  }

  .page-footer .page-footer-logo {
    flex: 0 0 auto;
    min-width: 220px;
    text-align: right;
  }

  .page-footer .page-footer-logo img {
    width: 233px;
    height: auto;
    max-width: 100%;
  }

  .page-footer .copyright {
    font-size: 0.95rem;
    color: #fff;
  }

  .page-footer .footer__link,
  .page-footer .footer__link:visited,
  .page-footer .footer__link:active,
  .page-footer .footer__link:focus {
    color: #fff !important;
    text-decoration: underline;
    text-underline-offset: 2px;
    text-decoration-thickness: 1px;
  }

  .page-footer .footer__link:hover {
    color: #fff !important;
    text-decoration: underline;
    text-underline-offset: 2px;
    text-decoration-thickness: 1px;
  }

  .page-footer .footer__link--button {
    font-weight: 300;
  }

  .button_base {
    background: none;
    border: none;
    padding: 0;
  }

  @media (max-width: 991.98px) {
    .page-footer .page-footer-cols {
      flex-direction: column;
      gap: 1.5rem;
    }

    .page-footer .page-footer-logo {
      text-align: left;
    }
  }
}
</style>
